import { defineComponent as _defineComponent } from 'vue'
import { User, StatusEnum } from "@/CodegenTypes";

import { sumBy, first } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "@/store/translation";
import { queries } from "@/apollo";
import { customMoment } from "@/main";

type DownlineBetSummaryRow = {
  userId: User["userId"];
  username: User["username"];
  status: StatusEnum;
  big: number;
  small: number;
  amount: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DownlineSummary',
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as {
  userId: User["userId"];
};

const route = useRoute();



const { $t } = useTranslation();

const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
});

const summaryQueryVariables = computed(() => ({
  releaseDate: customMoment(selectedStartReleaseDate.value)
    .startOf("day")
    .toDate(),
  behalfOf: props.userId,
}));

const { result, loading } = useQuery<{
  downlineBetSummary: DownlineBetSummaryRow[];
}>(
  queries.userAndDownlineBetSummary,
  summaryQueryVariables,
  {
    enabled: computed(() => !!selectedStartReleaseDate.value && !!props.userId),
  }
);

const downlineSummaryTotal = computed(() => {
  const data = downlineSummaryData.value;
  return {
    big: formatCount(sumBy(data, (d) => d.big)),
    small: formatCount(sumBy(data, (d) => d.small)),
    amount: formatDollar(sumBy(data, (d) => d.amount)),
  };
});

const downlineSummaryData = computed(() => {
  return result.value?.downlineBetSummary || [];
});

return { __sfc: true,route, props, $t, selectedStartReleaseDate, summaryQueryVariables, result, loading, downlineSummaryTotal, downlineSummaryData, formatDollar, formatCount }
}

})